import React, { useEffect, useMemo, useState } from 'react';
import { dayInfo, fetchOnThisDay, formatYear } from './wikipediaDay';

function OnThisDay() {
  const day = useMemo(() => dayInfo(), []);
  const [state, setState] = useState({ status: 'loading', events: [] });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading', events: [] });
    fetchOnThisDay(day)
      .then((events) => {
        if (!cancelled) setState({ status: 'ready', events });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error', events: [] });
      });
    return () => {
      cancelled = true;
    };
  }, [day, attempt]);

  return (
    <section id="on-this-day" className="ms-box fm-otd" aria-labelledby="otd-title">
      <h2 className="ms-box-title" id="otd-title">📅 On This Day: {day.label}</h2>
      <div className="ms-box-body">
        {state.status === 'loading' && <p className="ms-status" role="status">looking through the almanac...</p>}

        {state.status === 'error' && (
          <div role="alert">
            <p className="ms-error">Couldn't fetch today's events from Wikipedia.</p>
            <p className="fm-otd-actions">
              <button type="button" className="ms-btn ms-btn-small" onClick={() => setAttempt(n => n + 1)}>try again</button>
              <a className="ms-link" href={day.pageUrl} target="_blank" rel="noopener noreferrer">
                read {day.label} on Wikipedia ↗
              </a>
            </p>
          </div>
        )}

        {state.status === 'ready' && state.events.length === 0 && (
          <p className="ms-empty">Wikipedia lists no events for {day.label}.</p>
        )}

        {state.status === 'ready' && state.events.length > 0 && (
          <div className="ms-results fm-otd-list" tabIndex={0} role="region" aria-label={`Events on ${day.label}, newest first`}>
            <ul>
              {state.events.map((event, index) => (
                <li key={`${event.year}-${index}`}>
                  <strong className="fm-otd-year">{formatYear(event.year)}</strong>
                  <span> {event.text}</span>
                  {event.links.length > 0 && (
                    <span className="fm-otd-links">
                      {event.links.map(link => (
                        <a key={link.url} className="ms-link" href={link.url} target="_blank" rel="noopener noreferrer">
                          {link.title}
                        </a>
                      ))}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        <p className="ms-hint fm-otd-credit">
          From <a className="ms-link" href={day.pageUrl} target="_blank" rel="noopener noreferrer">Wikipedia, the free encyclopedia</a>{' '}
          (CC BY-SA 4.0). Newest first.
        </p>
      </div>
    </section>
  );
}

export default OnThisDay;
